import ItemRow from '../components/ItemRow';
import ItemActionButton from '../components/ItemActionButton';
import Paginated from '../components/Paginated';
import BackButton from '../components/BackButton';
import useAuth from '../contexts/useAuth';
import type { ListData } from '../../../types';

const Favorites = () => {
  const { user } = useAuth();
  const isAdmin = user?.isAdmin;

  return (
    <div className="page">
      <p className="section-title" style={{ marginTop: '20px' }}>
        Favorites
      </p>
      <BackButton />
      <div style={{ marginTop: '20px' }}>
        <Paginated<ListData>
          route="/api/favorites"
          render={(item) => (
            <div
              key={`favorites-${item.id}`}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                paddingRight: '10px',
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <ItemRow data={item} isAdmin={isAdmin} />
              </div>
              <ItemActionButton item={item} />
            </div>
          )}
          emptyMessage="No favorites yet"
        />
      </div>
    </div>
  );
};

export default Favorites;
